ui-bank-search-webform-general {
  display: block;

  // TODO: UI to display while form is loading totally SHOULD be part of cms-webforms
  .loading {
    display: flex;
    column-gap: 1em;
  }
}
